var map = {
	"./all-over-print.svg": 313348,
	"./handmade.svg": 206406,
	"./no.svg": 51203,
	"./placement-print.svg": 724345,
	"./pre-made-garment.svg": 556804,
	"./printed-fabric-meters.svg": 551181,
	"./yes.svg": 180391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757352;